/**
 * POSGuard — захист `/pos` route.
 *
 * Дозволяє доступ якщо user має `retail.sale.create`. Інакше → redirect /.
 */
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getMe } from '@/api/auth';
import { hasPermission } from '@/auth/permissions';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function POSGuard({ children }: Props) {
  const meQuery = useQuery({ queryKey: ['me'], queryFn: getMe });

  if (meQuery.isLoading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Завантаження...</div>;
  }

  if (!meQuery.data) {
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission(meQuery.data, 'retail.sale.create')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
